// This is a Jquery autocomplete plugin customized for the use of SumZero
// conor.hunt@gmail.com

!function( $ ){
  var SzAutoComplete = function ( element, options ) {
    this.$element = $(element)

    this.options = $.extend({}, $.fn.szautocomplete.defaults, options);

    if(this.$element.data('type')) {
      this.options.type = this.$element.data('type');
    }
    if(this.$element.data('id')) {
      this.options.idInput = this.$element.data('id');
    }
    if(this.$element.data('autosubmit')) {
      this.options.submitOnSelect = true;
    }
    if(this.$element.hasClass('theme-white')){
      this.options.whiteTheme = true;
    }
    this.setup();
  };

  SzAutoComplete.prototype = {
    constructor: SzAutoComplete,

    setup: function() {
      // If no results div is specified then create one and insert it
      if(this.options.resultsDiv == null) {
        if (this.options.whiteTheme){
          this.options.resultsDiv = $('<div data-role="ticker-matches" class="omni-box-results theme-white is-hide"></div>');
        } else {
          this.options.resultsDiv = $("<div class='autocomplete-results' style='display: none;'></div>")
        }

        this.$element.after(this.options.resultsDiv);

        // Extra left margin for bootstrap form control elements:
        if (this.$element.prev().hasClass('form-control')){
          this.options.resultsDiv.addClass('form-control-results');
        }

        var parentHeight = $(this.options.resultsDiv).parent().height()
      }

      var callbackTimeout = null;
      var szautocomplete = this;
      this.$element.on('keydown', function(event) {
        var $autocompleteDiv = $(this).next('.autocomplete-results');
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if(keycode == 13) { // Enter key
          event.preventDefault();
          var selectedValue = $autocompleteDiv.find('li.highlighted');
          if (!$(selectedValue).hasClass('new-item')) {
            this.value = $.trim(selectedValue.text());
          }
          $('.autocomplete-results').hide();
        } else if (keycode === 40) { // Down arrow
          $autocompleteDiv.show().addClass('keypress');
          if ($autocompleteDiv.find('li.highlighted').length === 0) {
            $autocompleteDiv.find('li:first').addClass('highlighted');
          } else {
            $autocompleteDiv.find('li.highlighted:first').removeClass('highlighted').next().addClass('highlighted');
          }
        } else if (keycode === 38) { // Up Arrow
          if ($autocompleteDiv.find('li.highlighted').length > 0) {
            $autocompleteDiv.find('li.highlighted:first').removeClass('highlighted').prev().addClass('highlighted');
          }
        } else if (keycode == 9 || (keycode == 9 && event.shiftKey) || keycode == 27 ) { // Tab & Escape
          $autocompleteDiv.hide().find('li.highlighted:first').removeClass('highlighted');
        } else {
          // Set a timeout that gets cancelled after 200ms, this way if the user
          // types multiple characters quickly we don't submit for every character
          clearTimeout(callbackTimeout);
          callbackTimeout = setTimeout(function() { szautocomplete.callServer() }, 200);
        }
      });

      //IE 8 keypress

      if ( (window.addEventListener === undefined) && document.attachEvent) { // Detect IE8
        this.$element.on('keyup', function(event){
          var $autocompleteDiv = $(this).next('.autocomplete-results');
          var keycode = (event.keyCode ? event.keyCode : event.which);
          if(keycode === 13) { // Enter key
            event.preventDefault();
            var selectedValue = $autocompleteDiv.find('li.highlighted').text().trim();
            this.value = selectedValue;
            $('.autocomplete-results').hide();
          }
        });
      }

      $('.autocomplete-results').mouseover(function(){
        $('.autocomplete-results').removeClass('keypress');
        $(this).find('li').removeClass('highlighted');
      });
    },

    callServer: function() {
      var text = this.$element.val();
      if (text !== "") {
        var szautocomplete = this;
        $.ajax({
          url: this.options.url,
          data: { q: text, type: this.options.type, allownew: this.options.allowNew },
          dataType: 'html',
          success: function(response) {
            szautocomplete.onSuccess(response)
          }
        });
      } else {
        this.options.resultsDiv.hide();
      }

    },

    onSuccess: function(response) {
      var resultsDiv = this.options.resultsDiv;
      var szautocomplete = this;

      if($.trim(response).length == 0) {
        resultsDiv.hide()
      } else {
        // Render into the results
        resultsDiv.html(response).show();
        // If there is a click on a result, set the text and id value
        resultsDiv.find('li').click( function() { szautocomplete.onResultClick($(this)) });

        // If we are allowed to create new items then look for a new item (may not exist)
        if(szautocomplete.options.allowNew) {
          resultsDiv.find('li.new-item').click( function() { szautocomplete.onNewItemClick(($this)) });
        }

        // If the user clicks off the results anywhere else on the page then close them
        $('html').one('click', function() { resultsDiv.hide(); });
      }
    },

    onResultClick: function(li) {
      if(this.options.onResultClick) {
        return this.options.onResultClick.call(this, li);
      }
      // Set the value of the input to the value of this li unless it is a new item
      if (!$(li).hasClass('new-item') ){
        this.$element.val(li.text());
      }


      // If there is an id input then set the value of that input
      if(this.options.idInput != null) {
        //this needs to be changed to li.data('id'), but I'm afraid of the consequences of doing so...
        $(this.options.idInput).val(li.data('id'));
      }
      this.options.resultsDiv.hide();

      if(this.options.submitOnSelect) {
        this.$element.parents('form:first').trigger('submit.rails');
      }
    },
    onNewItemClick: function(li) {
    }
  }

 /* SZAUTOCOMPLETE PLUGIN DEFINITION
  * ======================== */

  $.fn.szautocomplete = function ( option ) {
    // This style of jQuery plugin is taken from the twitter bootstrap
    // - It sets a data variable on each element (unless one is already created for that element)
    // - The data variable consists of the SzAutoComplete object.
    // - If there is already an existing SzAutoComplete for an element then it gives the
    //   passsed in options to the SzAutoComplete object.
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('szautocomplete')
        , options = typeof option == 'object' && option
      if (!data) $this.data('szautocomplete', (data = new SzAutoComplete(this, options)))
      else if (option) data.setOption(option)
    })
  }

  $.fn.szautocomplete.defaults = {
    // The div into which the results will be placed from the server
    // If no div exists one will be created
    resultsDiv: null,
    // The output from the server contains names and values
    // when a user clicks on a result the value will be put in the idInput
    idInput: null,
    url: '/pro/autocomplete',
    // Type of autocomplete. See the autocomplete controller for examples
    type: 'user',
    allowNew: false,
    // Callbacks
    onSuccess: null,
    onResultClick: null,
    // Should the containing form be submitted when an option is selected
    submitOnSelect: true
  }

  $.fn.szautocomplete.Constructor = SzAutoComplete

}( jQuery );
